export const DEFAULT_PROGRESS_STEPS = [
  {
    title: "Capture Vehicle Identity",
    key: "licenseplate_status",
    time_key: "licenseplate",
  },
  {
    title: "Capture Vehicle Usage",
    key: "dashboard_status",
    time_key: "dashboard",
  },
  {
    title: "Capture Vehicle Exterior",
    key: "exterior_status",
    time_key: "exterior",
  },
  {
    title: "Capture Vehicle Interior ",
    key: "interior_status",
    time_key: "interior",
  },
  {
    title: "Analyze Images",
    key: "submit_status",
    time_key: "submit",
  },
];
